package dev.mft.website.composable.footer

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.*
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import dev.mft.website.classes.Technology
import mft_website.composeapp.generated.resources.*

val technologies = listOf(
    Technology(
        resourceId = Res.drawable.java,
        contentDescription = "Java",
    ),
    Technology(
        resourceId = Res.drawable.kotlin,
        contentDescription = "Kotlin",
    ),
    Technology(
        resourceId = Res.drawable.spring,
        contentDescription = "Spring",
    ),
    Technology(
        resourceId = Res.drawable.ktor,
        contentDescription = "Ktor",
    ),
    Technology(
        resourceId = Res.drawable.postgres,
        contentDescription = "Postgres",
    ),
    Technology(
        resourceId = Res.drawable.mysql,
        contentDescription = "Mysql",
    ),
    Technology(
        resourceId = Res.drawable.mongodb,
        contentDescription = "MongoDB",
    )
)

val tools = listOf(
    Technology(
        resourceId = Res.drawable.git,
        contentDescription = "Git",
    ),
    Technology(
        resourceId = Res.drawable.gradle,
        contentDescription = "Gradle",
    ),
    Technology(
        resourceId = Res.drawable.maven,
        contentDescription = "Maven",
    ),
    Technology(
        resourceId = Res.drawable.jetpackcompose,
        contentDescription = "Jetpack Compose",
    ),
    Technology(
        resourceId = Res.drawable.kafka,
        contentDescription = "Kafka",
    ),
    Technology(
        resourceId = Res.drawable.docker,
        contentDescription = "Docker",
    )
)

@Composable
fun Skill(
    modifierBox: Modifier,
    fontSize: Float,
    imageSize: Float,
    padding: Dp
) {
    Box(
        modifier = modifierBox,
        contentAlignment = Alignment.Center
    ) {
        BoxWithConstraints {
            val calculatedImagesSize = minOf(maxWidth, maxHeight) * imageSize
            val calculatedTitleSize = (maxHeight.value * fontSize).sp

            Card(
                modifier = Modifier
                    .fillMaxWidth(0.8f)
                    .padding(padding),
                border = BorderStroke(1.dp, Color.Black),
                elevation = CardDefaults.cardElevation(
                    defaultElevation = 4.dp
                ),
                colors = CardDefaults.cardColors(Color.White)
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxSize(),
                    verticalArrangement = Arrangement.SpaceEvenly,
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(
                        "Tools and Technologies",
                        fontSize = calculatedTitleSize,
                        fontWeight = FontWeight.Bold,
                        textAlign = TextAlign.Center
                    )

                    SkillContent(
                        imageSize = calculatedImagesSize,
                        skills = technologies,
                        direction = -100f
                    )

                    SkillContent(
                        imageSize = calculatedImagesSize,
                        skills = tools,
                        direction = 100f
                    )
                }
            }
        }
    }
}